import script from "./AboutUsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutUsView.vue?vue&type=script&lang=ts&setup=true"

import "./AboutUsView.vue?vue&type=style&index=0&id=69a3c69c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69a3c69c"]])

export default __exports__